import { useEffect, Dispatch, SetStateAction } from 'react';

import { DOCUMENT_TAG_TYPES } from 'common/constants';

type UseScriptType = (args: {
  url?: string;
  body?: string;
  setLoaded?: Dispatch<SetStateAction<boolean>>;
  documentTag?: string;
  isDefer?: boolean;
}) => void;

const useScript: UseScriptType = ({ url, body, setLoaded, documentTag = DOCUMENT_TAG_TYPES.BODY, isDefer }) => {
  useEffect(() => {
    if (!body && !url) return;

    const script = document.createElement('script');

    if (url) script.src = url;
    if (body) script.innerHTML = body;

    if (isDefer) script.defer = true;
    script.onload = () => {
      if (setLoaded) setLoaded(true);
    };

    const targetElement = document[documentTag];
    if (targetElement) {
      targetElement.prepend(script);
    }

    return () => {
      if (targetElement && script.parentNode === targetElement) {
        targetElement.removeChild(script);
      }
    };
  }, [url, body, setLoaded, documentTag, isDefer]);
};

export default useScript;
